// extracted by mini-css-extract-plugin
module.exports = {"default":"button-module--default--1yXMO","outline":"button-module--outline--1HTWw","white":"button-module--white--13vD6","small":"button-module--small--3J6cZ"};